import { format, parseISO } from "date-fns";
import { SlidersHorizontal } from "lucide-react";
import { useState } from "react";
import { useBooking } from "../context/BookingContext";
import { BookingStepper } from "./BookingStepper";
import { ItinerarySidebar } from "./ItinerarySidebar";
import { SearchPanel } from "./SearchPanel";
import { MobileBookBar } from "./MobileBookBar";

const SearchSummary = () => {
  const { criteria, departure } = useBooking();
  const [open, setOpen] = useState(false);
  const d = (s) => format(parseISO(s), "d MMM");
  return (
    <div className="rounded-2xl border border-brand/10 bg-white/70 p-4 backdrop-blur" data-testid="search-summary">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="text-sm text-ink/70">
          <span className="font-medium text-ink">{criteria.hotel_name || "All hotels"}</span> · {d(criteria.arrival)} – {d(departure)} · {criteria.rooms} room(s), {criteria.adults + criteria.kids} guest(s) / room
          {criteria.promo && <span className="ml-2 rounded-full bg-gold/15 px-2 py-0.5 font-mono text-xs uppercase text-ink">{criteria.promo}</span>}
        </p>
        <button onClick={() => setOpen((o) => !o)} className="btn-ghost" data-testid="modify-search-toggle">
          <SlidersHorizontal className="h-4 w-4" /> {open ? "Close" : "Modify search"}
        </button>
      </div>
      {open && <div className="mt-5 border-t border-ink/10 pt-5"><SearchPanel onDone={() => setOpen(false)} /></div>}
    </div>
  );
};

export const StepLayout = ({ step, sidebarActions, mobileBar, children }) => (
  <div className="container-x pt-8">
    <SearchSummary />
    <BookingStepper current={step} />
    <div className="grid grid-cols-[minmax(0,1fr)] gap-8 lg:grid-cols-[minmax(0,1fr)_360px]">
      <div className="min-w-0 animate-rise">{children}</div>
      <ItinerarySidebar>{sidebarActions}</ItinerarySidebar>
    </div>
    {mobileBar && <MobileBookBar {...mobileBar} />}
  </div>
);
